export default __webpack_public_path__ + "static/media/zapatos-deportivos-hombre.c01d4a6c.png";